
// import axios from '../api/index';

export const Common = {
    state: () => ({
      buttonList : []
    }),
    mutations: {
      setButtonList(state, value) {
        state.buttonList = value;
      }
    },
    actions: {
      test() {
        // console.log(4);
      }
    },
    getters: {
    }
  };
